import request from '@/utils/request';
import { stringify } from 'qs';


// 订单中心列表
export async function getOrderCenterList (params: object) {
  return request(`/api/order/list?${stringify(params)}`, {})
}

/**
 * 订单详情
 * @param params
 * @returns {Promise<TResult|TResult2|TResult1>}
 */
export async function orderInfo(params: object) {
  return request(`/api/order/info?${stringify({
    ...params,
    v: new Date().getTime()
  })}`,{})
}

